/* TZ PLP AJAX Load-More — fetches next page, appends product cards inline. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tz-load-btn]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;

    var url = btn.getAttribute('href');
    if (!url) return;

    btn.classList.add('is-loading');
    var label = btn.querySelector('span:first-child');
    var origLabel = label ? label.textContent : 'Mehr laden';
    if (label) label.textContent = 'Laden…';

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector('[data-tz-plp-grid]');
        var curGrid = document.querySelector('[data-tz-plp-grid]');
        if (!nextGrid || !curGrid) return;

        var newCards = Array.prototype.slice.call(nextGrid.children);
        newCards.forEach(function (card) { curGrid.appendChild(card); });

        var nextLoadWrap = doc.querySelector('[data-tz-load-more]');
        var curLoadWrap = document.querySelector('[data-tz-load-more]');
        if (nextLoadWrap && curLoadWrap) {
          curLoadWrap.innerHTML = nextLoadWrap.innerHTML;
        } else if (curLoadWrap) {
          var endEl = curLoadWrap.querySelector('[data-end]');
          if (!endEl) {
            curLoadWrap.innerHTML = '<p class="tz-plp-load__btn" style="opacity:.6;">Alle geladen</p>';
          }
        }
      })
      .catch(function (err) {
        console.error('[tz-plp] load-more error', err);
        if (label) label.textContent = origLabel;
      })
      .finally(function () {
        btn.classList.remove('is-loading');
      });
  });
})();
